module.exports.config = {
  declarative: true,
  "render-module": {
    "name": "PieceHudsonCarouselRenderModule",
    "path": "front/piece-hudson-carousel-render.module"
  },
  definition: {
    type: "pieceHudsonCarousel",
    name: "PieceHudsonCarouselDefinition",
    group: "Carousels",
    availablePlatforms: ["web"],
    description: "Carrusel Dash Hudson",
    isNew: true,
    fields: [
      {
        name: "idAlbum",
        label: "Id del álbum",
        type: "plainText",
        mandatory: true
      },
      {
        name: "itemsPerRowFormat",
        type: "groupTabs",
        flattenFields: true,
        tabs: [
          {
            label: "ESCRITORIO",
            fields: ["itemsPerRowDesktop", "formatDesktop"]
          },
          {
            label: "MÓVIL",
            fields: ["itemsPerRow", "format"]
          },
        ],
        fields: [
          {
            name: "itemsPerRowDesktop",
            label: "Cantidad de elementos por fila",
            type: "plainText",
            defaultValue: "5",
            isExcluded: true,
            mandatory: true,
            validators: ["positiveInteger"]
          },
          {
            name: "itemsPerRow",
            label: "Cantidad de elementos por fila",
            type: "plainText",
            defaultValue: "8",
            mandatory: true,
            validators: ["positiveInteger"]
          },
          {
            name: "formatDesktop",
            label: "Formato",
            type: "options",
            defaultValue: "mosaic",
            isExcluded: true,
            values: [
              {
                label: "Mosaico",
                value: "mosaic"
              },
              {
                label: "Fila",
                value: "row",
              }
            ]
          },
          {
            name: "format",
            label: "Formato",
            type: "options",
            defaultValue: "mosaic",
            values: [
              {
                label: "Mosaico",
                value: "mosaic"
              },
              {
                label: "Fila",
                value: "row",
              }
            ]
          },
        ]
      }
    ]
  }
};
